import { BrowserRouter as Router, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import Header from "./components/Header.js";
import Login from "./views/Login.jsx";
import Register from "./views/Register.jsx";
import CreateOrder from "./views/CreateOrder.jsx";
import OrderDetails from "./views/OrderDetails.jsx";
import Profile from "./views/Profile.jsx";
import Dashboard from "./views/Dashboard.jsx";
import ForgotPassword from "./views/ForgotPassword.jsx";
import ResetPassword from "./views/ResetPassword.jsx";
import VerifyAccount from "./views/VerifyAccount.jsx"; // Import the new component

import Footer from "./components/Footer.js";
import FAQs from "./views/FAQs.jsx";
import PrivacyPolicy from "./views/PrivacyPolicy.jsx";
import About from "./views/About.jsx";
import Terms from "./views/Terms.jsx";
import Contact from "./views/Contact.jsx";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <ToastContainer />

      <Header />
      <main className="py-3">
        <Container>
          <Route exact path="/" component={Login} />
          <Route exact path="/forget-password" component={ForgotPassword} />
          <Route
            exact
            path="/password/reset/:token"
            component={ResetPassword}
          />
          <Route exact path="/register/:role" component={Register} />
          <Route exact path="/create" component={CreateOrder} />
          <Route exact path="/order/:id" component={OrderDetails} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/faqs" component={FAQs} />
          <Route exact path="/verify-account/:token" component={VerifyAccount} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/about" component={About} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/contact" component={Contact} />
        </Container>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
